import React, { useState, useEffect } from 'react';
import { getSettings } from '../../services/SettingsService';
import logger from '../../utils/logger';

function TelegramChat() {

    const [url, setUrl] = useState('');

    useEffect(() => {
        getSettings()
            .then(settings => setUrl(`https://api.telegram.org/bot${settings.telegramToken}/getUpdates`))
            .catch(err => logger.error(err))
    }, [])

    // Standalone helper page (opened in a new tab from the user modal): fill the
    // viewport and never add a second scrollbar to the host document.
    return <iframe src={url} title="Telegram Chats" style={{ display: 'block', width: '100%', maxWidth: '100%', height: '100vh', border: 0 }}></iframe>;
}

export default TelegramChat;